import React, { useState, useEffect, useRef } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import SpeechStudy from "./dashboard/SpeechStudy";
import RadcliffStudy from "./dashboard/RadcliffStudy";
import Ecas from "./dashboard/Ecas";
import Bridge from "../constants/Bridge";
import $ from "jquery";

const Dashboard = () => {
  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    Bridge.audit_logs.view_dashboard();
  }, []);

  return (
    <div className="dashboard-page">
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10 main_content_right_side"
          style={{
            minHeight: "100vh",
            paddingLeft: "32px",
            paddingRight: "30px",
            marginLeft: "auto",
            backgroundColor: "#F5F5F5",
          }}
        >
          <div className="main-section dashboard" style={{ marginTop: 105 }}>
            <div>
              <SpeechStudy />
              <RadcliffStudy />
              <Ecas />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
